import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { noop } from "@client/shared/constants";
import dialogStyles from "./style";

export default function WarningModule({
  isOpen = false,
  onClose = noop,
  content = "",
  handleDelete = noop,
  userPreference = false,
  patchPreference = noop,
  isButtonLoading = false,
  positiveLabel = "Delete",
  negativeLabel = "Cancel",
}) {
  const [checked, setChecked] = useState(userPreference);
  const handleDialogClose = () => {
    onClose();
  };
  useEffect(() => {
    setChecked(userPreference);
  }, [userPreference]);

  return (
    <Dialog open={isOpen} onClose={handleDialogClose}>
      <DialogTitle sx={dialogStyles.dialogTitle}>
        <IconButton onClick={handleDialogClose}>
          <CloseIcon sx={{ color: '#B0B0B0!important' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <InfoOutlinedIcon fontSize="large" sx={dialogStyles.warningIcon} />
        {/* <img src="/assets/warning.png" alt="Warning" /> */}
        <Typography variant="h4" sx={dialogStyles.heading}>
          Are you sure?
        </Typography>
        <Typography variant="body1">{content}</Typography>
        <Box sx={dialogStyles.checkboxWrapper}>
          <Checkbox
            checked={checked}
            onChange={(event) => {
              setChecked(event.target.checked);
              patchPreference(event.target.checked);
            }}
            color="primary"
            sx={dialogStyles.checkbox}
          />
          <Typography>Don't show this message again.</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={dialogStyles.actions}>
        <Button
          onClick={handleDialogClose}
          variant="outlined"
          sx={{
            ...dialogStyles.actionButtons,
            ...dialogStyles.cancelBtn,
          }}
        >
          {negativeLabel}
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          sx={dialogStyles.actionButtons}
          disabled={isButtonLoading}
        >
          {positiveLabel}
          {isButtonLoading && (
            <CircularProgress
              size={24}
              color="inherit"
              sx={{ position: "absolute" }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
